/**
 * Teks sub menu "Log Percakapan" (v2/M6) lapis 1 — tabel agregat per pengguna
 * di `/admin/ai-assistant/log`. Lapis 2 & 3: `assistant-log-detail.ts`.
 */
export interface AssistantLogText {
	navLabel: string;
	navDescription: string;
	title: string;
	subtitle: string;
	reload: string;
	rangeLabel: string;
	rangeOption: (days: number) => string;
	vendorLabel: string;
	statusLabel: string;
	modalityLabel: string;
	searchPlaceholder: string;
	all: string;
	statusOk: string;
	statusError: string;
	statusLimited: string;
	modalityText: string;
	modalityVoice: string;
	statActiveUsers: string;
	statConversations: string;
	statTurns: string;
	statTokens: string;
	statCost: string;
	tabUsers: string;
	tabTurns: string;
	colUser: string;
	colConversations: string;
	colTurns: string;
	colTokens: string;
	colCost: string;
	colDominantModel: string;
	colErrors: string;
	colLastActive: string;
	modelUnknown: string;
	costUnknown: string;
	/** Tanda bahwa estimasi kurang karena ada model tanpa tarif. */
	costIncomplete: string;
	none: string;
	loading: string;
	empty: string;
	loadFailed: string;
	footerRange: (from: string, to: string, total: string) => string;
	prevPage: string;
	nextPage: string;
	openUser: string;
}

const id: AssistantLogText = {
	navLabel: "Log Percakapan",
	navDescription: "Siapa bertanya apa, dijawab model mana",
	title: "Log Percakapan",
	subtitle: "Siapa bertanya apa, dijawab model mana — per pengguna.",
	reload: "Muat ulang",
	rangeLabel: "Rentang",
	rangeOption: (days) => (days === 1 ? "Hari ini" : `${days} hari terakhir`),
	vendorLabel: "Vendor",
	statusLabel: "Status",
	modalityLabel: "Modalitas",
	searchPlaceholder: "Cari nama atau email pengguna…",
	all: "Semua",
	statusOk: "Terjawab",
	statusError: "Gagal",
	statusLimited: "Kena plafon",
	modalityText: "Teks",
	modalityVoice: "Suara",
	statActiveUsers: "Pengguna aktif",
	statConversations: "Percakapan",
	statTurns: "Giliran ke penyedia",
	statTokens: "Token in/out",
	statCost: "Estimasi biaya",
	tabUsers: "Per Pengguna",
	tabTurns: "Semua Giliran",
	colUser: "Pengguna",
	colConversations: "Percakapan",
	colTurns: "Giliran",
	colTokens: "Token in / out",
	colCost: "Est. biaya",
	colDominantModel: "Model dominan",
	colErrors: "Error",
	colLastActive: "Terakhir aktif",
	modelUnknown: "tidak diketahui",
	costUnknown: "tarif belum diisi",
	costIncomplete: "sebagian model belum punya tarif",
	none: "—",
	loading: "Memuat log percakapan…",
	empty: "Belum ada pengguna yang memakai Jenna pada rentang dan filter ini.",
	loadFailed: "Log percakapan tidak dapat dimuat.",
	footerRange: (from, to, total) =>
		`Menampilkan ${from}–${to} dari ${total} pengguna`,
	prevPage: "Sebelumnya",
	nextPage: "Berikutnya",
	openUser: "Lihat percakapan pengguna ini",
};

const en: AssistantLogText = {
	navLabel: "Conversation Log",
	navDescription: "Who asked what, answered by which model",
	title: "Conversation Log",
	subtitle: "Who asked what, answered by which model — per user.",
	reload: "Reload",
	rangeLabel: "Range",
	rangeOption: (days) => (days === 1 ? "Today" : `Last ${days} days`),
	vendorLabel: "Vendor",
	statusLabel: "Status",
	modalityLabel: "Modality",
	searchPlaceholder: "Search user name or email…",
	all: "All",
	statusOk: "Answered",
	statusError: "Failed",
	statusLimited: "Hit the cap",
	modalityText: "Text",
	modalityVoice: "Voice",
	statActiveUsers: "Active users",
	statConversations: "Conversations",
	statTurns: "Provider turns",
	statTokens: "Tokens in/out",
	statCost: "Estimated cost",
	tabUsers: "Per User",
	tabTurns: "All Turns",
	colUser: "User",
	colConversations: "Conversations",
	colTurns: "Turns",
	colTokens: "Tokens in / out",
	colCost: "Est. cost",
	colDominantModel: "Dominant model",
	colErrors: "Errors",
	colLastActive: "Last active",
	modelUnknown: "unknown",
	costUnknown: "rate not set",
	costIncomplete: "some models have no rate yet",
	none: "—",
	loading: "Loading conversation log…",
	empty: "No user has used Jenna in this range and filter yet.",
	loadFailed: "The conversation log could not be loaded.",
	footerRange: (from, to, total) => `Showing ${from}–${to} of ${total} users`,
	prevPage: "Previous",
	nextPage: "Next",
	openUser: "View this user's conversations",
};

export const assistantLogTexts = { id, en } as const;
